/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./2048.vue?vue&type=template&id=5bb23d91&scoped=true"
import script from "./2048.vue?vue&type=script&lang=js"
export * from "./2048.vue?vue&type=script&lang=js"
import style0 from "./2048.vue?vue&type=style&index=0&id=5bb23d91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb23d91",
  null
  
)

export default component.exports